import * as vp from 'vopay';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBranding } from '@/providers/Branding.provider';
import useFetchLoginPageBranding from '@/hooks/useApi/useFetchLoginPageBranding';
import styles from './Login.module.scss';
import LoginRoutes from '@/components/LoginPages/Routes';
import { Card } from 'UI';

const { Box, Icon } = vp;

const Login = () => {
  const { logo, setBrandingValues, setSsoProviders } = useBranding();
  const [brandingLoaded, setBrandingLoaded] = useState(false);
  const { fetchLoginPageBranding } = useFetchLoginPageBranding();
  const { t } = useTranslation('translations', { keyPrefix: 'Login' });

  useEffect(() => {
    initBranding();
  }, []);

  async function initBranding() {
    const res = await fetchLoginPageBranding();

    if (!res.Success) {
      console.warn(res.ErrorMessage);
    }

    setBrandingValues({
      primaryColor: res.BrandingDetails.PrimaryColor,
      secondaryColor: res.BrandingDetails.SecondaryColor,
      logo: res.Logo,
      appTitle: res.AppTitle,
      appFavicon: res.Favicon,
    });

    setSsoProviders(res.SSOProviders ?? {});

    setBrandingLoaded(true);
  }

  return (
    <div className={styles.loginContainer}>
      {brandingLoaded && (
        <Box flx="col" ai="center" jc="center">
          <Card className={styles.formContainer}>
            {logo ? (
              <div className={styles.logoContainer}>
                <img
                  src={logo}
                  style={{
                    maxWidth: '175px',
                    maxHeight: '80px',
                    width: 'auto',
                    height: 'auto',
                    minHeight: '50px', // Prevents collapsing to 0x0
                    objectFit: 'contain',
                  }}
                  alt={t('logoAlt', { defaultValue: 'Logo' })}
                />
              </div>
            ) : (
              <div className={styles.logoContainer}>
                <Link to={{ pathname: 'https://vopay.com' }} target="_blank">
                  <Icon icon="vLogoText" width="100px" height="100px" />
                </Link>
              </div>
            )}

            <LoginRoutes />
          </Card>
        </Box>
      )}
    </div>
  );
};

export default Login;
